import { batch } from "solid-js";

import Transaction from "@repo/kikoff-models/Transaction";
import FeatureStore from "@repo/utils-solid/FeatureStore";

const initialState = {
  byId: {} as Record<Transaction.Id, Transaction>,
};

export const { Provider, useTransactions, Context } = FeatureStore.init(
  "Transactions",
  initialState,
  ([store, setStore], { wrapActions }) => {
    const accessors = {
      byId: (id: Transaction.Id) => store.byId[id],
    };

    const mutations = {
      one(transaction: Transaction) {
        setStore("byId", transaction.id, transaction);
      },
      many(transactions: Transaction[]) {
        batch(() => {
          for (const transaction of transactions) {
            mutations.one(transaction);
          }
        });
      },
    };

    const actions = wrapActions(mutations);

    return { accessors, actions };
  }
);
